function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectArrowDown = function SvgSelectArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 11,
    fill: "gray",
    viewBox: "0 0 13 8"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m11.293.293-4.59 4.58-4.59-4.58-1.41 1.41 6 6 6-6z",
    style: {
      fill: "currentColor"
    }
  }));
};
export { SvgSelectArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMyA4IiBmaWxsPSIjODA4MDgwIgogICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxzdHlsZT4KICAgICAgICAuZmlsbC1jb2xvciB7CiAgICAgICAgICAgIGZpbGw6IGN1cnJlbnRDb2xvcjsKICAgICAgICB9CiAgICA8L3N0eWxlPgogICAgPHBhdGggY2xhc3M9ImZpbGwtY29sb3IiIGQ9Ik0xMS4yOTMxIDAuMjkzMTI1TDYuNzAzMTIgNC44NzMxMkwyLjExMzEyIDAuMjkzMTI1TDAuNzAzMTI1IDEuNzAzMTJMNi43MDMxMiA3LjcwMzEyTDEyLjcwMzEgMS43MDMxMkwxMS4yOTMxIDAuMjkzMTI1WiIgLz4KPC9zdmc+Cg==";